export enum AuthEvent {
  SignIn = "auth_sign_in",
  SignUp = "auth_sign_up",
  ConfirmSignUp = "auth_confirm_sign_up",
  ForceNewPassword = "auth_force_new_password",
  ForgotPassword = "auth_forgot_password",
  ConfirmResetPassword = "auth_confirm_reset_password",
  SignOut = "auth_sign_out",
  Authenticated = "auth_authenticated",
  SignUpSubmit = "auth_sign_up_submit",
  SignUpSuccess = "auth_sign_up_success",
  SignUpError = "auth_sign_up_error",
  SignInSubmit = "auth_sign_in_submit",
  SignInSuccess = "auth_sign_in_success",
  SignInError = "auth_sign_in_error",
  SignInChallenge = "auth_sign_in_challenge",
  ConfirmCodeSubmit = "auth_confirm_code_submit",
  ConfirmCodeSuccess = "auth_confirm_code_success",
  ConfirmCodeError = "auth_confirm_code_error",
  ResendCode = "auth_resend_code",
  ForgotPasswordClick = "auth_forgot_password_click",
  ForgotPasswordSubmit = "auth_forgot_password_submit",
  ForgotPasswordSuccess = "auth_forgot_password_success",
  ForgotPasswordError = "auth_forgot_password_error",
  ResetPasswordSubmit = "auth_reset_password_submit",
  ResetPasswordSuccess = "auth_reset_password_success",
  ResetPasswordError = "auth_reset_password_error",
  ForceNewPasswordSubmit = "auth_force_new_password_submit",
  ForceNewPasswordSuccess = "auth_force_new_password_success",
  ForceNewPasswordError = "auth_force_new_password_error",
  InactivityLogout = "auth_inactivity_logout",
}

export const AUTH_ROUTE_TO_EVENT: Record<string, AuthEvent> = {
  signIn: AuthEvent.SignIn,
  signUp: AuthEvent.SignUp,
  confirmSignUp: AuthEvent.ConfirmSignUp,
  forceNewPassword: AuthEvent.ForceNewPassword,
  forgotPassword: AuthEvent.ForgotPassword,
  confirmResetPassword: AuthEvent.ConfirmResetPassword,
  signOut: AuthEvent.SignOut,
  authenticated: AuthEvent.Authenticated,
};
